export const SEO = {
  TYPES: {
    LIST: 'https://schema.org/BreadcrumbList',
    LIST_ITEM: 'https://schema.org/ListItem',
  },
  PROPS: {
    LIST_ELEMENT: 'itemListElement',
    ITEM: 'item',
    NAME: 'name',
    POSITION: 'position',
  },
};
